import React from "react";
import SeoMeta from "../components/SeoMeta";
import { SiteNav } from "../components/home/SiteNav";
import { SiteFooter } from "../components/home/BreathworkAndFooter";
import { Reveal, Eyebrow } from "../components/home/shared";
import { PageHero, Btn, EnquiryForm } from "../components/site/Sections";

const EMAIL = "events@feralcollective.co.uk";

const COPY = [
  "Rooted in the wild Anglesey landscape, we have three historic Welsh estates, minutes from the coastline. Whether you're hosting a wellbeing retreat or taking your team away for a day of strategy and reset, FERAL gives you the space, setting and support to make it count.",
  "Acres of private grounds. Manor house and cottage accommodation. Light-filled wellness studios, flexible meeting spaces, saunas, cold plunges and hot tubs. Everything you need to take people out of their routine and give them room to think, recover and connect.",
  "We run our own retreats and corporate gatherings across all three estates, and our team brings decades of experience delivering events of every scale. We're on hand to help you bring your ideas to life.",
  "Not only do we have our own in-house Therapeutic Practitioner, Calum, as well as Culinary Creator, Aimee, we also work with North Wales' best wellbeing, fitness, craft and hospitality practitioners, so you can build a programme around your goals. Choose from breathwork, guided hot and cold therapy, sound baths and yoga, through to cookery classes and hands-on craft workshops.",
  "Anglesey feels a world away, but it's easy to reach. Around an hour from Chester, with straightforward road links from Manchester and Liverpool, and direct rail services to Bangor and Holyhead. Close enough for a day. Far enough to properly switch off.",
];

const BLOCKS = [
  { title: "The space", copy: COPY[1], image: "/home/hottub.webp" },
  { title: "The team", copy: COPY[2], image: "/home/candle-dinner.webp" },
  { title: "The programme", copy: COPY[3], image: "/home/breathwork.webp" },
  { title: "Getting here", copy: COPY[4], image: "/home/anglesey-sea.webp" },
];

export default function VenueHire() {
  return (
    <div className="bg-[#f2e5de]" data-testid="venue-hire-page">
      <SeoMeta title="Corporate retreat and venue hire, North Wales | FERAL" description="Exclusive use of three historic Anglesey estates for offsites, retreats and events, planned by a team that knows corporate groups inside out." canonicalPath="/venue-hire" image="/innov-manor.jpg" />
      <SiteNav />
      <PageHero testid="venue-hero" eyebrow="FERAL" title="FERAL Corporate & Retreat Venue Hire" image="/innov-manor.jpg">
        <Btn href="#enquire" variant="outline" data-testid="venue-hero-enquire">Enquire about venue hire</Btn>
      </PageHero>

      <section className="feral-canvas py-24 md:py-36 px-6 md:px-10">
        <div className="max-w-[1500px] mx-auto grid md:grid-cols-12 gap-10">
          <Reveal className="md:col-span-4"><Eyebrow className="text-[#9b3d0a]">Exclusive use</Eyebrow></Reveal>
          <Reveal className="md:col-span-8" delay={0.1}>
            <p className="text-[#231f20]/85 text-lg md:text-xl font-light leading-relaxed max-w-3xl" data-testid="venue-intro">{COPY[0]}</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#2c6052] text-[#f2e5de]" data-testid="venue-blocks">
        {BLOCKS.map((b, i) => (
          <div key={b.title} className={`grid md:grid-cols-2 ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}>
            <div className="relative aspect-[4/3] md:aspect-auto md:min-h-[560px]"><img src={b.image} alt={b.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover" /></div>
            <div className={`px-6 md:px-16 lg:px-24 py-16 md:py-24 flex flex-col justify-center ${i % 2 ? "feral-canvas text-[#231f20]" : "bg-[#2c6052] feral-texture-dark"}`}>
              <Reveal><p className={`feral-serif text-xl mb-4 ${i % 2 ? "text-[#9b3d0a]" : "text-[#ebc754]"}`}>0{i + 1}</p><h2 className={`feral-serif text-4xl md:text-5xl leading-tight ${i % 2 ? "text-[#9b3d0a]" : "text-[#ebc754]"}`}>{b.title}</h2></Reveal>
              <Reveal delay={0.1}><p className={`mt-6 text-lg font-light leading-relaxed max-w-lg ${i % 2 ? "text-[#231f20]/80" : "text-[#f2e5de]/85"}`}>{b.copy}</p></Reveal>
            </div>
          </div>
        ))}
      </section>

      <section id="enquire" className="feral-canvas py-24 md:py-36 px-6 md:px-10 scroll-mt-20" data-testid="venue-enquire">
        <div className="max-w-[1500px] mx-auto grid md:grid-cols-12 gap-12">
          <Reveal className="md:col-span-5">
            <h2 className="feral-serif text-[#9b3d0a] text-5xl sm:text-6xl leading-[0.95] tracking-tight">Ready to plan?</h2>
            <p className="mt-8 text-[#231f20]/75 font-light">Or email us at <a href={`mailto:${EMAIL}`} className="text-[#9b3d0a] underline" data-testid="venue-email">{EMAIL}</a></p>
          </Reveal>
          <Reveal className="md:col-span-7" delay={0.1}>
            <EnquiryForm kind="venue-hire" fields={["company", "group_size", "dates"]} submitLabel="Enquire about venue hire" successText="Thank you — our events team will be in touch very soon." />
          </Reveal>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
